import {useAppContext} from "../../utils/AppContext";

const Pitch = () => {
    const {
        projectData,
        screenSize,
    } = useAppContext();

    // Styles Configuration //
    const pitchContainer = (!screenSize)? 'pitch-container' : `pitch-container pitch-container${screenSize}`;
    const pitchTopContainer = (!screenSize)? "pitch-top-container" : `pitch-top-container pitch-top-container${screenSize}`;
    const sectionTitle = (!screenSize)? "section-title" : `section-title section-title${screenSize}`;
    const largeTextLight = (!screenSize)? "large-text-light" : `large-text-light large-text-light${screenSize}`;
    const compareContainer = (!screenSize) ? "compare-container" : `compare-container compare-container${screenSize}`;
    const compareColumn = (!screenSize) ? "compare-column" : `compare-column compare-column${screenSize}`;
    const itemTitle = (!screenSize) ? "item-title" : `item-title item-title${screenSize}`;
    const pitchIconOthers = (!screenSize) ? "regular-text-light pitch-icon-others" : `regular-text-light pitch-icon-others${screenSize}`;
    const pitchIconUs = (!screenSize) ? "regular-text-light pitch-icon-us" : `regular-text-light pitch-icon-us${screenSize}`;
    const regularTextLight = (!screenSize) ? "regular-text-light" : `regular-text-light regular-text-light${screenSize}`;

    const pitchItemsOthers = ({item, index}) => {
        return (
        <div
            className="pitch-item-container"
            key={index}
        >
            <span className={pitchIconOthers}>&#215;</span>
            <p className={regularTextLight}>{item.description}</p>
        </div>
        )
    };
    const pitchItemsUs = ({item, index}) => {
        return (
        <div
            className="pitch-item-container"
            key={index}
        >
            <span className={pitchIconUs}>&#10003;</span>
            <p className={regularTextLight}>{item.description}</p>
        </div>
        )
    };

    return (
        <div className={pitchContainer}>
            <div className={pitchTopContainer}>
                <h2 className={sectionTitle}>{projectData.pitch.title}</h2>
                <p className={largeTextLight}>{projectData.pitch.description}</p>
            </div>
            <div className={compareContainer}>
                <div className={compareColumn}>
                    <h5 className={itemTitle}>{projectData.pitch.pitch_compare.pitch_others_title}</h5>
                    {projectData.pitch.pitch_compare.pitch_others_description.map((item, index) => (
                        pitchItemsOthers({item, index})
                    ))}
                </div>
                <div className={compareColumn}>
                    <h5 className={itemTitle}>{projectData.pitch.pitch_compare.pitch_us_title}</h5>
                    {projectData.pitch.pitch_compare.pitch_us_description.map((item, index) => (
                        pitchItemsUs({item, index})
                    ))}
                </div>
            </div>
        </div>
    );

};

export default Pitch;
